export default "__VITE_ASSET__4d66705b__"